import moment from "moment";

export default function TradeCard(props) {
  const item = props.item;
  return (
    <div className="menuContainer addHight text">
      <div
        className={`menuExchange  ${
          item.buy_sell == 0 ? "buytext" : "selltext"
        }`}
      >
        {item.buy_sell == 0 ? "BUY" : "SELL"}
      </div>
      <div className="menuSellQty">{item.symbol}</div>
      <div className="menuSellQty">{item.qty}</div>
      <div className="menuSellQty">
        {item.rate == null || item.rate == undefined || item.rate == ""
          ? 0
          : item.rate}
      </div>
      <div
        className={`menuSymbol small`}
        style={{
          textTransform: "uppercase",
          textAlign: "center",
        }}
      >
        {item.msg}
      </div>
      <div className="menuLtt">
        {moment(item.date_created).format("DD-MM-YYYY HH:mm:ss")}
      </div>
    </div>
  );
}
